import React from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
const VerifyForm = ({close, values, errors, isSubmitting, touched }) => {
    const isActive=Object.values(values)?.filter((v)=>v && v?.trim().length>0)?.length>=2;
    return (
        <Form className="uk-form-stacked">
            <div className="uk-width-1-1">
                <div className="uk-form-controls">
                    <div className={`uk-card uk-card-body border-default padding-10 bg-white border-radius-15  uk-width-1-1 ${touched.Website && errors.Website
                        && "uk-form-danger uk-animation-shake"}`}>
                        <label className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" htmlFor="cost">
                            Website URL
                        </label>
                        <div className="uk-form-controls">
                            <Field className={`uk-input borderless_input uk-form-small`} id="Website"
                                type="text"
                                name="Website"
                                placeholder="" />
                        </div>
                    </div>
                </div>
                <div className="uk-form-controls uk-margin-small-top">
                    <div className={`uk-card uk-card-body border-default padding-10 bg-white border-radius-15  uk-width-1-1 ${touched.Facebook && errors.Facebook
                        && "uk-form-danger uk-animation-shake"}`}>
                        <label className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" htmlFor="cost">
                        Facebook URL
                        </label>
                        <div className="uk-form-controls">
                            <Field className={`uk-input borderless_input uk-form-small`} id="Facebook"
                                type="text"
                                name="Facebook"
                                placeholder="" />
                        </div>
                    </div>
                </div>
                <div className="uk-form-controls uk-margin-small-top">
                    <div className={`uk-card uk-card-body border-default padding-10 bg-white border-radius-15  uk-width-1-1 ${touched.Instagram && errors.Instagram
                        && "uk-form-danger uk-animation-shake"}`}>
                        <label className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" htmlFor="cost">
                        Instagram URL
                        </label>
                        <div className="uk-form-controls">
                            <Field className={`uk-input borderless_input uk-form-small`} id="Instagram"
                                type="text"
                                name="Instagram"
                                placeholder="" />
                        </div>
                    </div>
                </div>
                <div className="uk-form-controls uk-margin-small-top">
                    <div className={`uk-card uk-card-body border-default padding-10 bg-white border-radius-15  uk-width-1-1 ${touched.Twitter && errors.Twitter
                        && "uk-form-danger uk-animation-shake"}`}>
                        <label className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" htmlFor="cost">
                        Twitter URL
                        </label>
                        <div className="uk-form-controls">
                            <Field className={`uk-input borderless_input uk-form-small`} id="Twitter"
                                type="text"
                                name="Twitter"
                                placeholder="" />
                        </div>
                    </div>
                </div>
                <div className="uk-form-controls uk-margin-small-top">
                    <div className={`uk-card uk-card-body border-default padding-10 bg-white border-radius-15  uk-width-1-1 ${touched.Other_Link && errors.Other_Link
                        && "uk-form-danger uk-animation-shake"}`}>
                        <label className="uk-form-label uk-text-left uk-margin-small-left uk-text-bold" htmlFor="cost">
                        Other URL
                        </label>
                        <div className="uk-form-controls">
                            <Field className={`uk-input borderless_input uk-form-small`} id="Other_Link"
                                type="text"
                                name="Other_Link"
                                placeholder="" />
                        </div>
                    </div>
                </div>

            </div>

            <div className="uk-text-right uk-margin-top">
                <button
                    onClick={close}
                    className="uk-width-1-5 uk-button uk-button-default uk-text-capitalize">
                    Cancel
                </button>
                <button
                    disabled={isSubmitting||!isActive}
                    type="submit"
                    className={`uk-width-1-5 uk-button uk-button-default  uk-margin-left uk-text-capitalize ${isActive && 'uk-button-danger'}`}>
                    {isSubmitting ? (
                        <i className="fa fa-spinner fa-spin fa-fw"></i>
                    ) : (
                        "Submit"
                    )}
                </button>

            </div>
        </Form>
    );
};

const VerificationForm = withFormik({
    mapPropsToValues({ Website,Facebook,Instagram,Twitter,Other_Link }) {
        return {
            Website: Website || "",
            Facebook: Facebook || "",
            Instagram: Instagram || "",
            Twitter: Twitter || "",
            Other_Link: Other_Link || "",


        };
    },
    validationSchema: Yup.object().shape({
        Website: Yup.string(),
        Facebook: Yup.string(),
        Instagram: Yup.string(),
        Twitter: Yup.string(),
        Other_Link: Yup.string(),
    }),
    handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
        props.handleSubmit(values).then(() => { setSubmitting(false);}).catch((err) => { setSubmitting(false) });
    },
})(VerifyForm);

export default VerificationForm;
